module.exports = __webpack_public_path__ + "static/media/techos-ico.dd030327.svg";